import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
/**
 * Componente para exibicao de mensagem de permissao negada
 * Implementa acessibilidade WCAG 2.1 AA
 */
var NoPermissionComponent = /** @class */ (function () {
    function NoPermissionComponent(route, router, translateService) {
        this.route = route;
        this.router = router;
        this.translateService = translateService;
        this.attemptedRoute = '';
        this.title = '';
    }
    NoPermissionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.attemptedRoute = params['attemptedRoute'] || '';
            _this.setTitle();
        });
    };
    /**
     * Define o título com base na rota e tradução
     */
    NoPermissionComponent.prototype.setTitle = function () {
        var _this = this;
        var featureKey = this.attemptedRoute.startsWith('/')
            ? this.attemptedRoute.substring(1)
            : this.attemptedRoute;
        this.translateService.get(["NO_PERMISSION.TITLE", "NO_PERMISSION.TITLE_FEATURE", "NO_PERMISSION.FEATURE." + featureKey]).subscribe(function (translations) {
            var title = translations["NO_PERMISSION.TITLE"] || 'Você não tem autorização para acessar';
            var titleFeature = translations["NO_PERMISSION.TITLE_FEATURE"] || '';
            var featureTranslation = translations["NO_PERMISSION.FEATURE." + featureKey];
            // Fallback para featureTranslation caso não exista ou seja igual à chave
            featureTranslation = featureTranslation && featureTranslation !== "NO_PERMISSION.FEATURE." + featureKey
                ? featureTranslation
                : _this.attemptedRoute;
            // Verifica se o resultado começa com EN4_ ou FM6_ e busca a tradução com .TRANSLATION
            if (featureTranslation.startsWith('EN4_') || featureTranslation.startsWith('FM6_')) {
                _this.translateService.get(featureTranslation + ".TRANSLATION").subscribe(function (translation) {
                    _this.title = title + ": " + (translation || featureTranslation);
                });
            }
            else {
                _this.title = title + ": " + featureTranslation;
            }
        });
    };
    /**
     * Navega para a pagina inicial
     */
    NoPermissionComponent.prototype.goHome = function () {
        this.router.navigate(['/']);
    };
    return NoPermissionComponent;
}());
export { NoPermissionComponent };
